/**
 * description 融合编辑器-新闻稿
 * created by he.zhikai
 * created on 2017-12-26
 */
'use strict';
angular.module('editFusionNewsModule', [])
    .controller('editFusionNewsCtrl', [
        '$scope',
        'editIsLock',
        'beforeonload',
        '$timeout',
        '$compile',
        '$controller',
        '$templateRequest',
        '$element',
        '$q',
        '$stateParams',
        '$state', 
        '$window',
        'iWoBtnService',
        'iWoinitBtnService',
        'initeditctrBtnsService',
        'filterEditctrBtnsService',
        'editFusionEditorService',
        'modalDialog',
        'storageListenerService',
        'trsHttpService',
        'editcenterRightsService',
        'ueditorService',
        'myManuscriptService',
        'editingCenterService',
        'messagePublishService',
        'newMediaService',
        'iWoService',
        'editingMediatype',
        function (
            $scope,
            editIsLock,
            beforeonload,
            $timeout,
            $compile,
            $controller,
            $templateRequest,
            $element,
            $q,
            $stateParams,
            $state,
            $window,
            iWoBtnService,
            iWoinitBtnService,
            initeditctrBtnsService,
            filterEditctrBtnsService,
            editFusionEditorService,
            modalDialog,
            storageListenerService,
            trsHttpService,
            editcenterRightsService,
            ueditorService,
            myManuscriptService,
            editingCenterService,
            messagePublishService,
            newMediaService,
            iWoService,
            editingMediatype
        ) {
            var pagesInfo = {};
            $scope = iWoService.addFuture($scope, ['sendmessage']);
            initStatus();
            initData();

            /**
             * [initStatus description] 初始化状态
             * @return {[type]} [description]
             */
            function initStatus() {
                $scope.data = {
                    navs: [{ // 左侧导航
                        MEDIANAME: '基础稿',
                        MEDIATYPE: '-1',
                        routerName: 'iwonews'
                    }],
                    errorNavs: [], // 保存出错的导航
                    successNavs: [], // 保存成功的导航
                    // trench:
                };
                $scope.status = {
                    doctype: editFusionEditorService.getDoctypeByRouter($state.current.name), // 稿件类型
                    navsDeleted: false, // 是否处于导航的删除状态
                    switch: 'manuscriptInfo', // 页面是否处于稿件信息
                    zhengwen: false, // 是否显示正文
                };
            }

            /**
             * [initData description] 初始化数据
             * @return {[type]} [description]
             */
            function initData() {
                // 编辑状态下请求绑定的渠道
                if (angular.isDefined($state.params.iwometadataid)) {
                    editIsLock.lockDraft($state.params.iwometadataid);
                    getBindingNavs().then(function (data) {
                        $scope.data.navs = data;
                        selectNav($scope.data.navs[0]).then(function () {
                            $scope.selectNav($scope.data.navs[0]);
                        });
                    });
                } else {
                    selectNav($scope.data.navs[0]);
                }
                initArrayBtn();
                $scope.handleBtnClick = function (funname) {
                    eval('$scope.' + funname + '()');
                };
            }


            /**
             * [getBindingNavs description] 获取绑定的渠道信息
             * @return {[type]} [description]
             */
            function getBindingNavs() {
                var defer = $q.defer();
                var params = {
                    serviceid: 'mlf_fusioncreate',
                    methodname: 'queryFuseMappings',
                    sourceDocId: $state.params.iwometadataid,
                    mediaTypes: ''
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                    var navs = [$scope.data.navs[0]]; // [{ MEDIANAME: "基础稿", MEDIATYPE: "-1", routerName: "iwonews" }];
                    angular.forEach(data, function (value, key) {
                        value.routerName = editFusionEditorService.getRouterByMediatype(value.MEDIATYPE, $scope.status.doctype);
                        navs.push(value);
                    });
                    queryResourceDocSubmitStatus().then(function (_data) {
                        $.extend(navs[0], _data);
                        defer.resolve(navs);
                    });
                });

                return defer.promise;
            }

            /**
             * [queryResourceDocSubmitStatus description]查询基础稿件是否已经提交过
             * @return {[type]} [description]
             */
            function queryResourceDocSubmitStatus() {
                var defer = $q.defer();
                var params = {
                    serviceid: 'mlf_fusioncreate',
                    methodname: 'queryResourceDocSubmitStatus',
                    sourceDocId: $state.params.iwometadataid,
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                    defer.resolve(data);
                });
                return defer.promise;
            }

            /**
             * [selectNav description] 选择导航
             * @param  {[type]} nav [description] 当前导航数据
             * @param {[type]} [dealWithListFun] [description] 处理list的方法
             * @return {[type]}     [description]
             */
            function selectNav(nav, dealWithListFun) {
                var defer = $q.defer();
                // 默认选中我的时不触发
                $state.params.issave = '0';
                $scope.$root.cureditpage = nav.routerName;
                $state.transitionTo($state.current.name, $state.params, { reload: false });
                if (!!$scope.data.selectedNav) {
                    saveList();
                    destroyController();
                }
                if (nav.controller) {
                    nav.controller.$scope.$destroy();
                }
                if (nav.status && nav.status.switch) {
                    nav.status.switch = 'manuscriptInfo'; // 切换后统一转入稿件信息标签；
                }
                $scope.data.selectedNav = nav;
                var navInfo = $state.get(nav.routerName).views[''];
                var templateUrl = navInfo.templateUrl;
                getTemplate(templateUrl, nav.routerName).then(function ($template) {
                    $element.find('.right').html($template);
                    $template = $element.find('.right').children().eq(0);
                    var controller = {};
                    controller.$scope = $scope.$new();
                    controller.$element = $template;
                    $template = $compile($template)(controller.$scope);
                    $controller(navInfo.controller, controller);
                    $scope.data.selectedNav.controller = controller;
                    $scope.fusionLoadingPromise = $scope.data.selectedNav.controller.$scope.initData(dealWithListFun).then(function () {
                        // 重新初始化发稿单指令
                        $scope.data.selectedNav.controller.$scope.loadFgd();
                        beforeonload.beforeonloadAlert($scope.data.selectedNav.controller.$scope);
                        defer.resolve();
                    });
                });
                return defer.promise;
            }

            /**
             * [selectNav description] 页面选择导航
             * @param  {[type]} nav [description] 当前的导航
             * @param {[type]} [isSave] [description] 在保存过程中切换渠道
             * @return {[type]}     [description]
             */
            $scope.selectNav = function (nav, isSave) {
                var defer = $q.defer();
                isSave = !!isSave;
                let selecteMediatype = $scope.data.selectedNav.MEDIATYPE * 1;
                // 如果所选导航和当前导航一致，则保持原样
                if (nav.MEDIATYPE * 1 === selecteMediatype) {
                    if (selecteMediatype === editingMediatype.iwo && $scope.data.selectedNav.SUBMITSTATUS == '1' && parseInt($scope.data.selectedNav.SUBMITTIMES) > 0) {
                        $scope.data.selectedNav.controller.$scope.status.isSubmit = true;
                        $scope.data.selectedNav.controller.$scope.pageCantEdit('manuscriptInfo');
                    }
                    defer.resolve();
                } else if (!nav.controller && angular.isUndefined(nav.VIRTUALDOCID)) { // 仅限新添加且第一次切换的渠道
                    // 如果在保存过程中切换渠道，且新渠道未初始化，则保存时跳过该渠道
                    if (isSave) {
                        defer.reject();
                    } else {
                        // 获取切换的左侧源渠道
                        var fromNavs = [];
                        for (var i = 0; i < $scope.data.navs.length; i++) {
                            if ($scope.data.navs[i].MEDIATYPE !== nav.MEDIATYPE && (!!$scope.data.navs[i].controller || angular.isDefined($scope.data.navs[i].VIRTUALDOCID))) {
                                fromNavs.push($scope.data.navs[i]);
                            }
                        }
                        editFusionEditorService.switchNavs(nav, fromNavs).then(function (result) {
                            let copyInfo = {};
                            // 如果选择不复制，则不将内容复制过来
                            if (result) {
                                for (var j = 0; j < $scope.data.navs.length; j++) {
                                    if ($scope.data.navs[j].MEDIATYPE * 1 === result.MEDIATYPE * 1) {
                                        copyInfo.copyList = angular.copy(result.controller.$scope.list);
                                        copyInfo.copyData = angular.copy(result.controller.$scope.data);
                                        break;
                                    }
                                }
                            }
                            selectNav(nav, function () {
                                // 如果选择不复制，则不将内容复制过来
                                editFusionEditorService.copyManuscript($scope, result, copyInfo);
                            }).then(function () {
                                $timeout(function () {
                                    // 将发稿单信息带过来
                                    editFusionEditorService.updateFgd($scope, $scope.data.selectedNav);
                                    // 将原创信息带过来
                                    editFusionEditorService.updateOriginal($scope, $scope.data.selectedNav);
                                    beforeonload.refresh($scope.data.selectedNav.controller.$scope);
                                    defer.resolve();
                                });
                            });
                        }, function () {
                            defer.reject();
                        });
                    }
                } else {
                    selectNav(nav, function () {
                        if (angular.isDefined($scope.data.selectedNav.list)) {
                            $scope.data.selectedNav.controller.$scope.list = angular.copy($scope.data.selectedNav.list);
                        }
                        if (angular.isDefined($scope.data.selectedNav.data)) {
                            $scope.data.selectedNav.controller.$scope.data = angular.copy($scope.data.selectedNav.data);
                        }
                        if (angular.isDefined($scope.data.selectedNav.status)) {
                            $scope.data.selectedNav.controller.$scope.status = angular.copy($scope.data.selectedNav.status);
                        }
                        if ($scope.data.selectedNav.hasError) {
                            delete $scope.data.selectedNav.hasError;
                            editFusionEditorService.formValidator($scope.data.selectedNav.controller.$scope, $scope.data.selectedNav.controller.$element);
                        }
                        // 编辑融合编辑稿件时将选中的报题对象带过去
                        $scope.data.selectedNav.controller.$scope.data.selectedReport = $scope.data.navs[0].controller.$scope.data.selectedReport;
                    }).then(function () {
                        $timeout(function () {
                            // 如果该渠道稿件已提交，则处于只读状态，无法再编辑
                            if ($scope.data.selectedNav.SUBMITSTATUS == '1' && parseInt($scope.data.selectedNav.SUBMITTIMES) > 0) {
                                $scope.data.selectedNav.controller.$scope.status.isSubmit = true;
                                $scope.data.selectedNav.controller.$scope.pageCantEdit('manuscriptInfo');
                            }
                            // 发稿单信息同步更新
                            editFusionEditorService.updateFgd($scope, $scope.data.selectedNav);
                            // 原创信息同步更新
                            editFusionEditorService.updateOriginal($scope, $scope.data.selectedNav, true);
                            // 查看痕迹权限同步更新
                            $scope.data.selectedNav.controller.$scope.status.bigFaceRights = $scope.status.bigFaceRights;
                            // 初始化发稿单需要时间
                            $timeout(function () {
                                defer.resolve();
                            }, 500);
                        });
                    });
                }
                return defer.promise;
            };

            /**
             * [destroyController description] 销毁控制器
             * @return {[type]} [description]
             */
            function destroyController() {
                $scope.data.selectedNav.controller.$scope.$destroy();
                $('#ueditor').remove();
                $('.sp-container').remove();
                $('#edui_fixedlayer').remove();
            }

            /**
             * [saveList description] 切换时保存list数据
             * @return {[type]}     [description]
             */
            function saveList() {
                ueditorService.saveContent($scope.data.selectedNav.controller.$scope.list);
                $scope.data.selectedNav.list = angular.copy($scope.data.selectedNav.controller.$scope.list);
                $scope.data.selectedNav.data = angular.copy($scope.data.selectedNav.controller.$scope.data);
                $scope.data.selectedNav.status = angular.copy($scope.data.selectedNav.controller.$scope.status);
                // 保存状态之前要先关闭大花脸 --start
                $scope.data.selectedNav.status.bigFaceSwitch = { status: false };
                // 保存状态之前要先关闭大花脸 --end
                $scope.data.list = angular.copy($scope.data.selectedNav.controller.$scope.list);
                $scope.data.data = angular.copy($scope.data.selectedNav.controller.$scope.data);
                $scope.data.status = angular.copy($scope.data.selectedNav.controller.$scope.status);
            }

            /**
             * [getTemplate description] 获取模板
             * @param {string} [templateUrl] [description] 模板地址
             * @param {string} [pageName] [description] 模板名称
             * @return {[type]} [description]
             */
            function getTemplate(templateUrl, pageName) {
                var deffer = $q.defer();
                if (!!pagesInfo[pageName]) {
                    deffer.resolve(pagesInfo[pageName].$template.clone());
                    return deffer.promise;
                }
                $templateRequest(templateUrl).then(function (template) {
                    var $dom = $(template);
                    pagesInfo[pageName] = {
                        $template: $dom
                    };
                    deffer.resolve(pagesInfo[pageName].$template.clone());
                });
                return deffer.promise;
            }

            /**
             * [initArrayBtn description] 初始化权限按钮
             * @return {[type]} [description]
             */
            function initArrayBtn() {
                var fromType = $stateParams.fromType;
                if (fromType === 'departmentmanuscript') {
                    $scope.iWoBtns = iWoinitBtnService.initBtnArrays()[2];
                    initeditctrBtnsService.initDepartmentData($state.params.departmentaldocid).then(function (data) {
                        $scope.arrayBtn = filterEditctrBtnsService.filterBtn(data, $scope.iWoBtns);
                        addBtn();
                    });
                } else {
                    $scope.methodnameArray = ['iwo.personal', 'iwo.received'];
                    $scope.dictionaryArray = [iWoBtnService.initIwoPersonBtn(), iWoBtnService.initIwoReceiveBtn()];
                    $scope.iWoBtns = iWoinitBtnService.initBtnArrays()[$state.params.iwoplatform];
                    initeditctrBtnsService.initIwoData($scope.methodnameArray[$state.params.iwoplatform]).then(function (data) {
                        initeditctrBtnsService.initBtns(data, $scope.dictionaryArray[$state.params.iwoplatform]).then((btns) => {
                            $scope.btnStatus = btns;
                            $scope.arrayBtn = filterEditctrBtnsService.filterBtn($scope.btnStatus, $scope.iWoBtns);
                            addBtn();
                        });
                    });
                }
                // 获取查看痕迹按钮权限
                editcenterRightsService.initIwoListBtn('iwo.trace').then(function (data) {
                    $scope.status.bigFaceRights = !!data['iwo.trace.chakan'] ? 'true' : 'false';
                });
            }

            /**
             * [addBtn description]新增的按钮类型
             *
             * @return  {[type]}  [return description]
             */
            function addBtn() {
                $scope.arrayBtn.unshift({
                    RIGHTINDEX: 'save',
                    OPERDESC: '保存',
                    OPERNAME: '保存',
                    OPERFUN: 'save'
                });
                $scope.arrayBtn.push({
                    RIGHTINDEX: 'savethenclose',
                    OPERDESC: '保存并关闭',
                    OPERNAME: '保存并关闭',
                    OPERFUN: 'savethenclose'
                });
            }

            /**
             * [savethenclose description] 保存并关闭
             * @return {[type]} [description]
             */
            $scope.savethenclose = function () {
                $scope.status.saveType = false; // 保存类型，为undefined或true时，代表保存时要加锁
                editingCenterService.saveAndClose($scope.save);
            };

            /**
             * [addNavs description]添加到渠道
             *
             * @return  {[type]}  [return description]
             */
            $scope.addNavs = function () {
                // 获取已有渠道（由于对象里包含控制器，无法直接copy对象）
                var nowNavs = [];
                for (var i = 0; i < $scope.data.navs.length; i++) {
                    nowNavs.push($scope.data.navs[i]);
                }
                editFusionEditorService.addNavs($scope.status.doctype, nowNavs, $state.params.iwometadataid).then(function (result) {
                    $scope.data.navs = result;
                });
            };

            /**
             * [deleteNavs description] 移除导航
             * @param  {[type]} nav [description] 当前导航数据
             * @return {[type]}     [description]
             */
            $scope.deleteNavs = function (nav) {
                modalDialog.confirmModal('删除渠道', '确认删除当前渠道', function () {
                    deleteNavsRequest(nav).then(function () {
                        // 如果删除的是当前渠道，则删除后默认选中下一个或上一个渠道
                        if (nav.MEDIATYPE === $scope.data.selectedNav.MEDIATYPE) {
                            for (var i = 0; i < $scope.data.navs.length; i++) {
                                if (nav.MEDIATYPE === $scope.data.navs[i].MEDIATYPE) {
                                    break;
                                }
                            }
                            $scope.data.navs.splice($scope.data.navs.indexOf(nav), 1);
                            $scope.selectNav($scope.data.navs[0]);
                        } else {
                            $scope.data.navs.splice($scope.data.navs.indexOf(nav), 1);
                        }
                        // 删除相应的路由参数
                        if (nav.MEDIATYPE === '1') {
                            delete $state.params.appchnldocid;
                            delete $state.params.appmetadataid;
                        } else if (nav.MEDIATYPE === '2') {
                            delete $state.params.wzchnldocid;
                            delete $state.params.wzmetadataid;
                        } else if (nav.MEDIATYPE === '3') {
                            delete $state.params.papermetadataid;
                        } else if (nav.MEDIATYPE === '4') {
                            delete $state.params.wxmetadataid;
                            delete $state.params.wxchnldocid;
                        } else if (nav.MEDIATYPE === '5') {
                            delete $state.params.wbmetadataid;
                        } else if (nav.MEDIATYPE === '18') {
                            delete $state.params.baijiahaoarticleid;
                        } else if (nav.MEDIATYPE === '19') {
                            delete $state.params.qiehaoarticleid;
                        } else if (nav.MEDIATYPE === '20') {
                            delete $state.params.articleid;
                        }
                        storageListenerService.addListenerToIwo('newsSaved');
                        $state.transitionTo($state.current, $state.params, {
                            reload: false
                        });
                        // 当只剩我渠道时，收起关闭图标
                        if ($scope.data.navs.length === 1) {
                            $scope.status.navsDeleted = false;
                        }
                    });
                });
            };

            /**
             * [deleteNavsRequest description] 删除导航的请求
             * @param {[type]} [nav] [description] 当前导航
             * @return {[type]} [description]
             */
            function deleteNavsRequest(nav) {
                var defer = $q.defer();
                // 如果是已绑定的渠道，则需要调请求删除
                if (angular.isDefined(nav.VIRTUALDOCID)) {
                    var params = {
                        serviceid: 'mlf_fusioncreate',
                        methodname: 'removeMediaRelate',
                        sourceDocId: $state.params.iwometadataid,
                        mediaType: nav.MEDIATYPE
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                        if (data.ISSUCCESS == 'true') {
                            defer.resolve();
                        } else {
                            defer.reject();
                        }
                    }, function () {
                        defer.reject();
                    });
                } else {
                    defer.resolve();
                }
                return defer.promise;
            }

            /**
             * [description] 监听页面是否处于稿件信息
             * @param  {[type]} newValue  [description]
             * @param  {[type]} oldValue  [description]
             * @return {[type]}           [description]
             */
            $scope.$watch('data.selectedNav.controller.$scope.status.switch', function (newValue, oldValue) {
                $scope.status.switch = newValue;
                // 如果该渠道稿件已提交，则处于只读状态，无法再编辑
                if (angular.isDefined($scope.data.selectedNav) && angular.isDefined($scope.data.selectedNav.controller) && $scope.data.selectedNav.controller.$scope.status.isSubmit && newValue != 'processVersion') {
                    $scope.data.selectedNav.controller.$scope.pageCantEdit(newValue);
                }
            });

            /**
             * [toggleEditor description] 展开正文或收起正文
             * @return {[type]} [description]
             */
            $scope.toggleEditor = function () {
                $scope.status.zhengwen = !$scope.status.zhengwen;
                $scope.data.selectedNav.controller.$scope.status.zhengwen = $scope.status.zhengwen;
                if ($scope.status.zhengwen) { // 隐藏编辑器
                    $('.body_manuscript_content').addClass('editorHidden');
                } else {
                    $('.body_manuscript_content').removeClass('editorHidden');
                }
            };

            /**
             * [packageNav description]组装保存渠道信息
             * @return {[type]} [description]
             */
            function packageNav() {
                $scope.data.copyNavs = [];
                for (var i = 0; i < $scope.data.navs.length; i++) {
                    $scope.data.copyNavs.push({
                        MEDIANAME: $scope.data.navs[i].MEDIANAME + '稿件',
                        MEDIATYPE: $scope.data.navs[i].MEDIATYPE,
                        saveStatus: 'pending',
                    });
                }
            }


            /* 稿件操作开始*/
            /**
             * [save description] 保存稿件
             * @param {[type]} [flag] [description] 是否为操作前的保存
             * @return {[type]} [description]
             */
            $scope.save = function (flag) {
                var defer = $q.defer();
                var index = 0;
                // 涉密信息提示
                modalDialog.isSecretInformation($state.params.iwometadataid, function () {
                    packageNav();
                    // 过滤没有复制的渠道
                    var savenavs = $scope.data.navs.filter((nav) => {
                        if (nav.controller || nav.VIRTUALDOCID) {
                            if (nav.SUBMITSTATUS) {
                                if (nav.SUBMITSTATUS === '2') {
                                    return nav;
                                }
                            } else {
                                return nav;
                            }
                        }
                    });
                    $scope.status.saveInfo = modalDialog.multiSaveInfo([savenavs.length]);
                    // 保存开始刷新路由，为了保存过程中不提示是否恢复本地版本
                    $state.params.issave = '1';
                    // // $state.params = angular.copy($stateParams);
                    $state.transitionTo($state.current, $state.params, {
                        reload: false
                    });
                    $scope.fusionLoadingPromise = saveDrafts($scope.data.navs[index]).then(function () {
                        // 第五步，各渠道保存后完成后的地方
                        // 保存成功后的处理
                        storageListenerService.addListenerToIwo('newsSaved');
                        // 保存结束刷新路由
                        $state.params.issave = '0';
                        // // $state.params = angular.copy($stateParams);
                        $state.transitionTo($state.current, $state.params, {
                            reload: false
                        });
                        // 重新获取左侧导航
                        getBindingNavs().then(function (data) {
                            var tempNavsArray = [];
                            for (var i = 0; i < $scope.data.navs.length; i++) {
                                // 如果有保存失败的渠道，则在渠道上标记
                                for (var j = 0; j < $scope.data.errorNavs.length; j++) {
                                    if ($scope.data.navs[i].MEDIATYPE == $scope.data.errorNavs[j].MEDIATYPE) {
                                        $scope.data.navs[i].hasError = true;
                                    }
                                }
                                // 如果新添加的渠道并没有被保存成功，那么暂时先保留该渠道
                                var hasNav = false;
                                for (var k = 0; k < data.length; k++) {
                                    if (data[k].MEDIATYPE == $scope.data.navs[i].MEDIATYPE) {
                                        data[k].controller = $scope.data.navs[i].controller;
                                        data[k].list = $scope.data.navs[i].list;
                                        data[k].hasError = $scope.data.navs[i].hasError;
                                        tempNavsArray.push(data[k]);
                                        hasNav = true;
                                    }
                                }
                                if (!hasNav) {
                                    tempNavsArray.push($scope.data.navs[i]);
                                }
                            }
                            $scope.data.navs = tempNavsArray;
                            // 如果当前渠道已被新对象替换，则重新对其进行绑定
                            for (var l = 0; l < $scope.data.navs.length; l++) {
                                if ($scope.data.selectedNav.MEDIATYPE == $scope.data.navs[l].MEDIATYPE) {
                                    $scope.data.selectedNav = $scope.data.navs[l];
                                    break;
                                }
                            }
                            $scope.data.errorNavs = [];
                        });
                        // 所有页面均无错误时，提示保存成功
                        if ($scope.data.errorNavs.length === 0) {
                            if (!flag) {
                                $timeout(() => {
                                    $scope.status.saveInfo.dismiss();
                                }, 600);
                                modalDialog.saveModel('保存成功', '', 'success');
                            }
                            defer.resolve();
                        }
                    }, function (error) {
                        // 第五步
                        // 保存结束刷新路由
                        $state.params.issave = '0';
                        // // $state.params = angular.copy($stateParams);
                        $state.transitionTo($state.current, $state.params, {
                            reload: false
                        });
                    });
                }, function (msg) {
                    modalDialog.alertType('保存失败', '请检查填写项', 'warning', false);
                    defer.reject(msg);
                });
                return defer.promise;

                /**
                 * [saveDrafts description] 保存稿件方法
                 * @param  {[type]} nav [description] 稿件渠道
                 * @return {[type]}     [description]
                 */
                function saveDrafts(nav) {
                    var defer = $q.defer();
                    saveList();
                    saveDraftsByNavs(nav, function (msg) {
                        defer.resolve(msg);
                    }, function (error) {
                        // 第四步
                        defer.reject(error);
                    });
                    return defer.promise;
                }

                /**
                 * [saveDraftsByNavs description] 分渠道保存稿件
                 * @param  {[type]} nav     [description] 稿件渠道
                 * @param  {[type]} success [description] 全部保存成功回调
                 * @param  {[type]} error   [description] 保存失败回调
                 * @return {[type]}         [description]
                 */
                function saveDraftsByNavs(nav, success, error) {
                    var defer = $q.defer();
                    // 如果该渠道已经提交过，则不再进行保存操作
                    if (nav.SUBMITSTATUS == '1' && parseInt(nav.SUBMITTIMES) > 0) {
                        index++;
                        if (index === $scope.data.navs.length) {
                            success();
                        } else {
                            saveDraftsByNavs($scope.data.navs[index], success, error);
                        }
                    } else {
                        getDataAndValidateForm(nav).then(function () {
                            // 我的以外的渠道，把我的的metadataid传入（参数要用）
                            if (nav.MEDIATYPE !== '-1') {
                                nav.controller.$scope.data.sourceDocId = $state.params.iwometadataid;
                                nav.controller.$scope.data.mediaType = nav.MEDIATYPE;
                            }
                            var orgMetadataId = nav.controller.$scope.list.METADATAID;
                            // 直接调各渠道编辑页控制器内的保存方法
                            nav.controller.$scope.save($scope.status.saveType).then(function () {
                                publishSaveStatus(index, true);
                                index++;
                                if ($scope.$root.cureditpage !== nav.routerName && orgMetadataId == '0') {
                                    var map = {
                                        'newspapertext': 'newsPaper',
                                        'websitenews': 'website',
                                        'appnews': 'app',
                                        'iwonews': 'iwo',
                                        'wxeditpage': 'weixin',
                                        'baijiahaonews': 'baijiahao',
                                        'qiehaonews': 'qiehao'
                                    };
                                    ueditorService.deleteLocalTempVersion(map[nav.routerName]);
                                }
                                if (nav.MEDIATYPE === '-1') {
                                    $state.params.iwochnldocid = angular.isDefined($state.params.iwochnldocid) ? $state.params.iwochnldocid : nav.controller.$scope.list.CHNLDOCID;
                                    $state.params.iwometadataid = angular.isDefined($state.params.iwometadataid) ? $state.params.iwometadataid : nav.controller.$scope.list.METADATAID;
                                    if (nav.list) {
                                        nav.list.CHNLDOCID = $state.params.iwochnldocid;
                                        nav.list.METADATAID = $state.params.iwometadataid;
                                    }
                                } else if (nav.MEDIATYPE === '1') {
                                    $state.params.appchnldocid = angular.isDefined($state.params.appchnldocid) ? $state.params.appchnldocid : nav.controller.$scope.list.CHNLDOCID;
                                    $state.params.appmetadataid = angular.isDefined($state.params.appmetadataid) ? $state.params.appmetadataid : nav.controller.$scope.list.METADATAID;
                                    if (nav.list) {
                                        nav.list.CHNLDOCID = $state.params.appchnldocid;
                                        nav.list.METADATAID = $state.params.appmetadataid;
                                    }
                                } else if (nav.MEDIATYPE === '2') {
                                    $state.params.wzmetadataid = angular.isDefined($state.params.wzmetadataid) ? $state.params.wzmetadataid : nav.controller.$scope.list.METADATAID;
                                    $state.params.wzchnldocid = angular.isDefined($state.params.wzchnldocid) ? $state.params.wzchnldocid : nav.controller.$scope.list.CHNLDOCID;
                                    if (nav.list) {
                                        nav.list.METADATAID = $state.params.wzmetadataid;
                                        nav.list.CHNLDOCID = $state.params.wzchnldocid;
                                    }
                                } else if (nav.MEDIATYPE === '3') {
                                    $state.params.papermetadataid = angular.isDefined($state.params.papermetadataid) ? $state.params.papermetadataid : nav.controller.$scope.list.METADATAID;
                                    if (nav.list) {
                                        nav.list.METADATAID = $state.params.papermetadataid;
                                    }
                                } else if (nav.MEDIATYPE === '4') {
                                    $state.params.wxmetadataid = angular.isDefined($state.params.wxmetadataid) ? $state.params.wxmetadataid : nav.controller.$scope.list.METADATAID;
                                    $state.params.wxchnldocid = angular.isDefined($state.params.wxchnldocid) ? $state.params.wxchnldocid : nav.controller.$scope.list.CHNLDOCID;
                                    if (nav.list) {
                                        nav.list.METADATAID = $state.params.wxmetadataid;
                                        nav.list.CHNLDOCID = $state.params.wxchnldocid;
                                    }
                                } else if (nav.MEDIATYPE === '5') {
                                    $state.params.wbmetadataid = angular.isDefined($state.params.wbmetadataid) ? $state.params.wbmetadataid : nav.controller.$scope.list.FUSIONSCMID;
                                    if (nav.list) {
                                        nav.list.FUSIONSCMID = $state.params.wbmetadataid;
                                    }
                                } else if (nav.MEDIATYPE === '18') {
                                    $state.params.baijiahaoarticleid = angular.isDefined($state.params.baijiahaoarticleid) ? $state.params.baijiahaoarticleid : nav.controller.$scope.list.baijiahaoarticleid;
                                    if (nav.list) {
                                        nav.list.FUSIONSCMID = $state.params.baijiahaoarticleid;
                                    }
                                } else if (nav.MEDIATYPE === '19') {
                                    $state.params.qiehaoarticleid = angular.isDefined($state.params.qiehaoarticleid) ? $state.params.qiehaoarticleid : nav.controller.$scope.list.qiehaoarticleid;
                                    if (nav.list) {
                                        nav.list.FUSIONSCMID = $state.params.qiehaoarticleid;
                                    }
                                } else if (nav.MEDIATYPE === '20') {
                                    $state.params.articleid = angular.isDefined($state.params.articleid) ? $state.params.articleid : nav.controller.$scope.list.articleid;
                                    if (nav.list) {
                                        nav.list.FUSIONSCMID = $state.params.articleid;
                                    }
                                }
                                delete nav.hasError;
                                if (index === $scope.data.navs.length) {
                                    success();
                                } else {
                                    saveDraftsByNavs($scope.data.navs[index], success, error);
                                }
                                defer.resolve();
                            }, function (msg) { // reject
                                // 第三步
                                // 如果我的保存失败，则不再进行下面渠道的保存
                                if ((nav.MEDIATYPE == '-1' && !$state.params.iwometadataid) || !msg.METADATAID) { // 新增没有ID保存不成功判断
                                    nav.hasError = true;
                                    $timeout(function () {
                                        publishSaveStatus(index, false);
                                        error(msg);
                                    }, 200);
                                } else { // 如果我的保存成功，我的以外的某个渠道保存失败，则继续下面其他渠道的保存
                                    $timeout(function () { // 稍微延时下解决基础稿保存失败时还没打开弹窗的问题
                                        publishSaveStatus(index, false);
                                        index++;
                                        $scope.data.errorNavs.push(nav);
                                        if (index === $scope.data.navs.length) {
                                            success(msg);
                                        } else {
                                            saveDraftsByNavs($scope.data.navs[index], success, error);
                                        }
                                        defer.reject(msg);
                                    }, 200);
                                }

                            });
                        }, function () {
                            index++;
                            if (index === $scope.data.navs.length) {
                                success();
                            } else {
                                saveDraftsByNavs($scope.data.navs[index], success, error);
                            }
                        });
                    }
                    return defer.promise;
                }
            };

            /**
             * [publishSaveStatus description]发布保存状态
             * @param  {[obj]} index [description]渠道下标
             * @param  {[bol]} flag  [description]标识
             * @return {[type]}      [description]
             */
            function publishSaveStatus(index, flag) {
                $scope.data.copyNavs[index].saveStatus = flag;
                messagePublishService.publish('fusionSaveInfo', { list: $scope.data.copyNavs[index] });
            }

            /**
             * [getDataAndValidateForm description] 获取数据并校验表单
             * @param {object} [nav] [description] 导航对象
             * @return {[type]} [description]
             */
            function getDataAndValidateForm(nav) {
                var deffer = $q.defer();
                if (nav.controller || angular.isDefined(nav.VIRTUALDOCID)) {
                    if (nav.MEDIATYPE === $scope.data.selectedNav.MEDIATYPE) {
                        deffer.resolve();
                        return deffer.promise;
                    }
                    if (nav.controller) {
                        nav.controller.$scope.$destroy();
                        beforeonload.destroy(nav.controller.$scope);
                    }
                    var navInfo = $state.get(nav.routerName).views[''];
                    var templateUrl = navInfo.templateUrl;
                    getTemplate(templateUrl, nav.routerName).then(function ($template) {
                        var controller = {};
                        controller.$scope = $scope.$new();
                        controller.$element = $template;
                        $template = $compile($template)(controller.$scope);
                        $controller(navInfo.controller, controller);
                        nav.controller = controller;
                        nav.$element = $template;
                        nav.controller.$scope.initData(function () {
                            if (angular.isDefined(nav.list)) {
                                nav.controller.$scope.list = angular.copy(nav.list);
                                // editFusionEditorService.formValidator($scope.data.selectedNav.controller.$scope, $scope.data.selectedNav.controller.$element);
                            }
                            if (angular.isDefined(nav.data)) {
                                nav.controller.$scope.data = angular.copy(nav.data);
                            }
                            if (angular.isDefined(nav.status)) {
                                nav.controller.$scope.status = angular.copy(nav.status);
                            }
                        }).then(function () {
                            // 重新初始化发稿单指令
                            nav.controller.$scope.loadFgd();
                            $timeout(function () {
                                // 发稿单信息同步更新
                                editFusionEditorService.updateFgd($scope, nav);
                                // 原创信息同步更新
                                editFusionEditorService.updateOriginal($scope, nav);
                                beforeonload.beforeonloadAlert(nav.controller.$scope);
                                deffer.resolve();
                            }, 1000);
                        });
                    });
                } else {
                    deffer.reject();
                }
                return deffer.promise;
            }

            /**
             * [iWoSubmit description] 稿件提交
             * @return {[type]} [description]
             */
            $scope.iWoSubmit = function () {
                let methodname = ['PersonalSubmitDoc', 'ReceivedSubmitDoc', 'submit'];
                $scope.status.saveType = false; // 保存类型，为undefined或true时，代表保存时要加锁
                $scope.save(true).then(function () { // 提交放在保存后是因为提交内逻辑是需要实体稿件信息才能执行
                    if ($state.params.departmentaldocid){ // 部门稿库需要加锁
                        editIsLock.lockDraft($state.params.iwometadataid);   
                    }
                    $scope.submitList = [{
                        CHNLDOCID: $state.params.iwochnldocid,
                        METADATAID: $state.params.iwometadataid,
                        DOCTYPEID: editFusionEditorService.getDoctypeByRouter($state.current.name),
                    }];
                    newMediaService.iwoSubmit($scope, methodname[$state.params.iwoplatform]);
                });
            };


            /**
             * [iWoshare description] 部门提交
             * @return {[type]} [description]
             */
            $scope.departmentSubmit = function () {
                $scope.status.saveType = false; // 保存类型，为undefined或true时，代表保存时要加锁
                $scope.save(true).then(function () { // 因为融合编辑器问题 此代码暂时无法更换
                    editIsLock.lockDraft($state.params.iwometadataid);
                    departmentSubmit();
                });
            };

            /**
             * [departmentSubmit description] 部门提交
             * @return {[type]} [description]
             */
            function departmentSubmit() {
                editFusionEditorService.departmentSubmit($scope);
            }

            /**
             * [iWoshare description] 稿件共享
             * @return {[type]} [description]
             */
            $scope.iWoshare = function () {
                $scope.status.saveType = false; // 保存类型，为undefined或true时，代表保存时要加锁
                newMediaService.iwoShare($scope).then((shareObj) => {
                    $scope.save(true).then(function () {
                        messagePublishService.publish('doEditPageOperation', iWoService.packageShareParams(shareObj));
                    });
                });
            };

            /**
             * [iWoTransfer description] 稿件传稿
             * @return {[type]} [description]
             */
            $scope.iWoTransfer = function () {
                $scope.status.saveType = false; // 保存类型，为undefined或true时，代表保存时要加锁
                $scope.save(true).then(function () {
                    draft();
                });
            };
            
            /**
             * [draft description] 稿件传稿方法
             * @return {[type]} [description]
             */
            function draft() {
                editIsLock.normalLock($state.params.iwometadataid).then(function () {
                    var iwoData = [{
                        'CHNLDOCID': $state.params.iwochnldocid,
                        'METADATAID': $state.params.iwometadataid
                    }];
                    var menthod = ['personalTransferMetaDatas', 'receivedTransferMetaDatas'];
                    myManuscriptService.draft('传稿', iwoData, function () {
                        storageListenerService.addListenerToIwo('newsPassed');
                        var opened = $window.open('about:blank', '_self');
                        opened.close();
                    }, function () { }, menthod[$state.params.iwoplatform]);
                });
            }

            /* 稿件操作结束*/
        }
    ]);
